<template>
  <div class="haulage-dashboard-main">
    <div class="filter-jobs-container">
      <div class="filter-jobs">
        <div :style="{ backgroundColor: filterImp ? 'rgb(255, 160, 122)' : 'rgba(128,128,128,0.5)', textDecoration: filterImp ? 'none' : 'line-through' }" @click="filterClicked('i')">IMP</div>
        <div :style="{ backgroundColor: filterExp ? 'rgb(173, 216, 230)' : 'rgba(128,128,128,0.5)', textDecoration: filterExp ? 'none' : 'line-through' }" @click="filterClicked('e')">EXP</div>
      </div>
    </div>
    <div class="container-haulage-dashboard" ref="cont">
      <div class="jobs" v-for="(j, i) in jobInquiry" :key="i" :style="{ backgroundColor: `${j['BckColor']}`, color: j['FontColor'] }" @click="retrieveViewOptionList(j.ViewOption)">
        <div class="view-option">{{ j.ViewOption }}</div>
        <div class="view-option-count" v-if="filterImp && filterExp">{{ j.IMP + j.EXP }}</div>
        <div class="view-option-count" v-else-if="filterImp && !filterExp">{{ j.IMP }}</div>
        <div class="view-option-count" v-else-if="!filterImp && filterExp">{{ j.EXP }}</div>
      </div>
    </div>

    <div class="tablebox-optionDetails" v-if="optionDetailsList && optionDetailsList.length > 0">
      <img src="https://dsmapi.logistics.systems/dsm6gIcons/Cancel.png" @click="closeViewOptionList()"> 
      <TableBox class="table-box" :title="optionDetailsTableBoxTitle" :tableData="optionDetailsTableBoxItems" :dataType="optionDetailsTableBoxDataType" :maxSelection="0" />
    </div>

    <div :style="{ height: `calc(100% - (45px + ${jobsHeight}px))`, width: '100%', position: 'relative', padding: '5px', backgroundColor: 'white', borderRadius: '5px' }">
      <div class="box-section">
        <div style="flex:1; display:flex;">
          <div style="flex:1; display:flex;">
            <Dropdown class="view-option-dropdown" placeholder="View" :items="viewOptions" itemKey="Description" :selectedObject.sync="selectedViewOption" />
          </div>
        </div>
        <div class="date-section" style="flex:1; justify-content:right;">
          <DateTimePicker :value.sync="hmsStart" :maxDate="hmsEnd" :style="{margin:'5px 7px 5px 5px'}" :showTime="false" placeholder="Date From"/>
          <DateTimePicker :value.sync="hmsEnd" :minDate="hmsStart" :style="{margin:'5px 10px 5px 8px'}" :showTime="false" placeholder="To"/>
          <button  @click="ganttRefresh" style="margin-left: 5px; float: right; margin: 5px;">Refresh</button>
          <div class="last-refresh">Last Refreshed : {{ lastRefresh }}</div>
        </div>
      </div>
      <GanttChartV2 :items="ganttItems" ref="gantt-chart" style="height: calc(100% - 38px)" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function() {
    return {
      hmsStart: new Date(new Date().getFullYear(), 0, 1), // first day of current year
      hmsEnd: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0), // last day of current month

      lastRefresh: '',

      jobInquiry: [],
      ganttItems: [],

      filterImp: true,
      filterExp: true,

      jobsHeight: 0,
      viewOptions: [],
      selectedViewOption: null,
      optionDetailsList: [],
      optionDetailsTableBoxTitle: "",
      optionDetailsTableBoxItems: [],
      optionDetailsTableBoxDataType: {
        "Size": "number",
        "Request Date": "date",
        "eCMR Received Date": "date",
        "Required Date": "date",
        "ETA": "date",
        "Opening Date": "date",
        "Closing": "date",
        "Gatepass Time": "datetime",
        "Pickup Time": "datetime",
        "Del StageIn Time": "datetime",
        "Deliver Time": "datetime",
        "RFC Time": "datetime",
        "Collect Time": "datetime",
        "Dropoff Time": "datetime",
        "Last Day Storage": "date",
        "Last Day Demurrage": "date",
        "Last Day Detention": "date",
        "Fumigation Time": "datetime",
      },
    }
  },
  props: {
    hmsData: { type: Array, default: function() { return [] } },
  },
  methods: {
    refreshClicked: async function(){
      if (!this.hmsStart || !this.hmsEnd) {
        //this.$alert.showAlert('Invalid Date','Please select a valid date from the dropdown list','error');
        this.$showAlert('error', 'Invalid Date', 'Please select a valid date from the dropdown list');
        return;
      }

      if (!this.selectedViewOption) {
        //this.$alert.showAlert('Invalid View','Please select a valid view from the dropdown list','error');
        this.$showAlert('error', 'Invalid View', 'Please select a valid view from the dropdown list');
      }

      this.$emit('refreshClicked');
    },
    filterClicked: function(filter) {
      if (filter == 'i') {
        this.filterImp = !this.filterImp;
        this.filterExp = true;
      } else if (filter == 'e') {
        this.filterExp = !this.filterExp;
        this.filterImp = true;
      }

      if (this.optionDetailsList && this.optionDetailsList.length > 0) { // if tablebox is shown
        if (this.filterImp && this.filterExp) {
          this.optionDetailsTableBoxItems = this.optionDetailsList;
        } else if (!this.filterImp && this.filterExp) {
          this.optionDetailsTableBoxItems = this.optionDetailsList.filter(a => a['JobType'].includes('EXP'));
        } else if (this.filterImp && !this.filterExp) {
          this.optionDetailsTableBoxItems = this.optionDetailsList.filter(a => a['JobType'].includes('IMP'));
        }
      }
    },
    ganttRefresh: async function() {
      if (!this.selectedViewOption) {
        //this.$alert.showAlert('Invalid View', 'Please select a valid View from the dropdown list', 'error');
        this.$showAlert('error', 'Invalid View', 'Please select a valid View from the dropdown list');
        return;
      }

      this.$fullscreenLoading("Getting Gantt Data");
      this.ganttItems = (await this.$apiCallV2(`/HaulageDashboard/GanttViewTASV2?start=${this.$dateTime.getDateTime(this.hmsStart, 'yyyy-MM-dd')}&end=${this.$dateTime.getDateTime(this.hmsEnd, 'yyyy-MM-dd')}&viewType=${this.selectedViewOption['View Option']}`));
      this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');
      // this.setStartEndDate(ganttData);

      this.$fullscreenLoading();
    },
    setStartEndDate: function(oriData) { // UNUSED
      if (oriData.length == 0) {
        return;
      }   
      // Set inital end date
      var allItems = oriData;
      allItems.forEach((i) => {
        var date = new Date(i.start_date.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));
        if (date != 'Invalid Date' && i.duration) {
          i.myEndDate = date.setMinutes(date.getMinutes() + (i.duration * 30));
        }
      });
      // Set inital end date

      // Sort, get the minimum date and convert the value to a date obj
      allItems.sort((a, b) => {
        var dateA = new Date(a.start_date.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));
        var dateB = new Date(b.start_date.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));

        return dateA < dateB ? -1 : 1;
      });

      var minDate;
      for (var i = 0; i < allItems.length; i++) {
        var testDate = new Date(allItems[i].start_date.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));
        if (testDate != 'Invalid Date') {
          minDate = allItems[i].start_date;
          break;
        }
      }

      var minDateObj = new Date(minDate.replace(/(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2})/, "$2/$1/$3 $4:$5"));
      // Sort, get the minimum date and convert the value to a date obj

      // Sort and get the maximum date which is the end date
      allItems.sort((a, b) => {
        if (!a.myEndDate) {
          a.myEndDate = 0;
        }
        if (!b.myEndDate) {
          b.myEndDate = 0;
        }

        return a.myEndDate < b.myEndDate ? 1 : -1;
      });
      // Sort and get the maximum date which is the end date

      oriData.ganttStart = minDateObj;
      oriData.ganttEnd = new Date(allItems[0].myEndDate);

      this.hmsData = oriData;
    },
    retrieveViewOptionList: async function(viewoption) {
      this.$fullscreenLoading("Getting Option List");
      this.optionDetailsList = [];
      this.optionDetailsList = await this.$apiCallV2(`/HaulageDashboard/GetJobInquiryViewOptionList?viewOption=${viewoption}`);

      this.optionDetailsTableBoxTitle = viewoption;
      if (this.filterImp && this.filterExp) {
        this.optionDetailsTableBoxItems = this.optionDetailsList;
      } else if (!this.filterImp && this.filterExp) {
        this.optionDetailsTableBoxItems = this.optionDetailsList.filter(a => a['JobType'].includes('EXP'));
      } else if (this.filterImp && !this.filterExp) {
        this.optionDetailsTableBoxItems = this.optionDetailsList.filter(a => a['JobType'].includes('IMP'));
      }

      this.$fullscreenLoading();
      this.$nextTick(() => {
        this.$refs['gantt-chart'].pageResize();
      });
    },
    closeViewOptionList: function() {
      this.optionDetailsList = [];
      this.$nextTick(() => {
        this.$refs['gantt-chart'].pageResize();
      });
    }
  },
  async mounted() {
    this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');

    var today = new Date();

    this.hmsStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 0, 0);
    this.hmsEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1, 23, 59);

    this.$fullscreenLoading("Getting Job Inquiry");
    this.jobInquiry = await this.$apiCallV2(`/HaulageDashboard/GetJobInquiry`);

    this.$fullscreenLoading("Getting View Option");
    this.viewOptions = await this.$apiCallV2(`/HaulageDashboard/GetListMaster?masterFile=HMSCAPACITYVIEW`);
    this.selectedViewOption = this.viewOptions[0];

    this.$nextTick(() => {
      this.$refs['gantt-chart'].pageResize(); // getting gantt data may take a while, call pageResize while it loads
    });

    this.$fullscreenLoading("Getting Gantt Data");
    this.ganttItems = await this.$apiCallV2(`/HaulageDashboard/GanttViewTASV2?start=${this.$dateTime.getDateTime(this.hmsStart, 'yyyy-MM-dd HH:mm')}&end=${this.$dateTime.getDateTime(this.hmsEnd, 'yyyy-MM-dd HH:mm')}&viewType=${this.selectedViewOption['View Option']}`);
    // this.setStartEndDate(ganttData);

    this.$fullscreenLoading();

    this.$nextTick(() => {
      this.jobsHeight = this.$refs["cont"].clientHeight;
    })
  },
  watch:{
    hmsStart: function(val) {
      this.$emit('update:hmsStart', val);
    },
    hmsEnd: function(val) {
      this.$emit('update:hmsEnd', val);
    },
  }, 
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.date-section{
  display: inline-block;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.last-refresh{
  padding: 5px 0;
}

.box-section{
  display: flex;
  align-items: center;

  > * {
    white-space: nowrap;
  }
}

.haulage-dashboard-main {
  padding: 10px 45px;
  font-size: 12px;
  // display: flex;
  // flex-direction: column;
  // align-items: center;

  > .filter-jobs-container {
    display: flex;
    width: 100%;
    justify-content: center;

    > .filter-jobs {
      width: fit-content;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      border-radius: 5px;
      margin-bottom: 5px;

      > div {
        border-radius: 3px;
        border: 1px solid rgba(128, 128, 128, 0.5);
        margin: 5px;
        padding: 5px 10px;
        cursor: pointer;
        transition: $transition-time;
      }
    }
  }

  > .container-haulage-dashboard {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    margin-bottom: 5px;

    > .jobs {
      cursor: pointer;
      height: 100px;
      width: 100px;
      border: 1px solid black;
      border-radius: 3px;
      margin: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 10px;
      user-select: none;
      
      .view-option {
        height: 60px;
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        // padding-bottom: 5px;
      }

      .view-option-count {
        font-size: 22px;
        height: 60px;
        width: 100%;
      }
    }
  }

  .tablebox-optionDetails {
    height: 80%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    margin-bottom: 5px;
    max-height: 600px;

    > img {
      width: 30px;
      height: 30px;
      position: relative;
      left: calc(100% - 30px);
      cursor: pointer;
    }

    > .table-box {
      height: calc(100% - 30px);
    }
  } 

  .view-option-dropdown {
    width: 40%;
  }
}




</style>